import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Card, CardBody, FormFeedback, Label, Input } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";
import moment from 'moment';

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { checkCSVFileValidation } from "../../Utils/Common";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { saveAs } from 'file-saver';
import Papa from "papaparse";

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const UserManagement = props => {
  const [modal_Delete_User, setmodal_Delete_User] = useState(false);
  function Delete_User() {
    setmodal_Delete_User(!modal_Delete_User);
    // removeBodyCss();
  }


  
  //meta title
  document.title = "User Management";
	const location = useLocation();
  const { getRequest, postRequest, postRequestByFormData } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};
  
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      kyc_status: 'All',
      status: 'All',
      country: {label: 'All', value: 'All'},
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = UsersData;
        if(values.kyc_status !== 'All') {
          filteredData = filteredData.filter(item => item.kyc_status === values.kyc_status);
        }
        if(values.status !== 'All') {
          filteredData = filteredData.filter(item => item.status === values.status);
        }
        if(values.country.value !== 'All') {
          filteredData = filteredData.filter(item => item.country === values.country.value);
        }

        if(filteredData.length > 0) {
          handleT1Body(filteredData);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="9" className="text-center">No records found</td>
                        </tr>);

          setUsersTBody(tempTBody);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      u_id: elementData.u_id,
      status: elementData.status,
    });
    setStandardModal2(true);
  }

  const [StandardModal3, setStandardModal3] = React.useState(false);
  const togStandardModal3 = async () => {
    setStandardModal3(true);
  }

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      u_id: '',
      status: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Please select status'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          u_id: values.u_id,
          status: values.status
        });
        const res = await postRequest('update-user-status', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetUsers();
          setTimeout(() => {
            validation1.handleSubmit();
          }, 500);

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal2(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  }); 

  const [isDisabled, setIsDisabled] = useState(false);
  const completeRegistrationMail = async (u_id) => {
      setIsDisabled(true); 
      
      const jsonpar = JSON.stringify({ u_id: u_id });
      const res = await postRequest('complete-registration-mail', jsonpar);

      if (res && res.code === 200) {  
          setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
          }));
      }
      else {
          setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
          }));
      }
      resetAlertData();
  }

  const [StandardModal, setStandardModal] = React.useState(false);
  const togStandardModal = async (elementData) => {
    validation.setValues({
      ...validation.values,
          u_id: elementData.u_id,
      });
      setStandardModal(true);
  }

      const validation = useFormik({
          enableReinitialize: true,
  
          initialValues: {
          u_id: '',
          welcome_bonus: '',
          referral_code: ''
          },
          validationSchema: Yup.object({
            welcome_bonus: Yup.number()
            .typeError('Welcome bonus must be a number')
            .required('Please enter welcome bonus')
            .positive('Welcome bonus must be greater than 0'),
            referral_code: Yup.string().required('Please enter referral code'),
          }),
          onSubmit: async (values) => {
          try {
              let submit1 = document.getElementById('submit1');
              submit1.disabled = true;
              submit1.textContent = 'Processing...';
  
              const jsonpar = JSON.stringify({
              u_id: values.u_id,
              collaborator_welcome_bonus: values.welcome_bonus,
              collaborator_referral_code: values.referral_code
              });
              const res = await postRequest('make-collaborator', jsonpar);
              if (res && res.code === 200) {  
                  setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'success',
                  message: res.message,
                  }));
              }
              else {
              setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'error',
                  message: res.message,
              }));
              }
              resetAlertData();
              
              submit1.disabled = false;
              submit1.textContent = 'Submit';
  
              setStandardModal(false);
              handleLoadGetUsers();
          } catch (error) {
              console.error("Error : ", error);
          }
          }
      });

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [UsersData, setUsersData] = React.useState([]);
  const [UsersTBody, setUsersTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    setCsvData(tempData);
    const formatAddressPart = (value) => {
      return value && value.trim() !== "" ? value : "";
    };
    let tempTBody = tempData.map((element, index) => (
        <tr key={element.u_id}>
        <td>
          <input
            type="checkbox"
            checked={selectedUsers.includes(element.u_id)}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedUsers(prev => [...prev, element.u_id]);
              } else {
                setSelectedUsers(prev => prev.filter(id => id !== element.u_id));
              }
            }}
          />
        </td>
        <td>{element.u_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.email}</td>
        <td>{element.country}</td>
        <td>
          {element.phone ? (
            <>
              +{element.country_code} {element.phone.slice(0, 6)}****&nbsp;
              {parseInt(element.is_phone_verified) === 1 ? (
                <CheckCircleIcon style={{ color: 'green' }} />
              ) : (
                <CancelIcon style={{ color: 'red' }} />
              )}
            </>
          ) : (
            ""
          )}
        </td>
        <td>
            {(() => {
              if (element.dob) {
                return moment(element.dob).format('DD/MM/YYYY');
              } else {
                return "-";
              }
            })()}
          </td>
         {/* <td>
          {(() => {
            const fullAddress = [
              formatAddressPart(element.street),
              formatAddressPart(element.city),
              formatAddressPart(element.postal_code),
              formatAddressPart(element.state),
              formatAddressPart(element.address_country),
            ]
              .filter(part => part.trim() !== "") // remove empty parts
              .join(" ")
              .trim();

            // If fullAddress is empty, fall back to element.address
            return fullAddress !== "" ? fullAddress : (element.address || "-");
          })()}
        </td> */}
        <td>{element.address ? element.address : "-"}</td>
        <td>{element.building}</td>
        <td>{element.floor}</td>
        <td>{element.zip}</td>
        <td>{element.tax_residency}</td>
        <td>{element.tax_id}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.kyc_status === 'Pending' ? 'badge-soft-warning' : element.kyc_status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.kyc_status}</span></td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Enable' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span></td>
        <td>{`${parseFloat(element.euro_available_balance).toFixed(2)} EUR`}</td>
        <td>{`${parseFloat(element.euro_available_balance).toFixed(2)-parseFloat(element.total_bonus-element.used_bonus).toFixed(2)} EUR`}</td>
        <td>{`${parseFloat(element.total_bonus-element.used_bonus).toFixed(2)} EUR`}</td>
        <td>{`${parseFloat(element.matic_available_balance).toFixed(2)} MATIC`}</td>
        <td>{`${parseFloat(element.usdt_available_balance).toFixed(2)} USDT`}</td>
        <td>{`${parseFloat(element.total_bonus).toFixed(2)} EUR`}</td>
        <td>{`${parseFloat(element.welcome_bonus).toFixed(2)} EUR`}</td>
        <td>{`${parseFloat(element.referral_bonus).toFixed(2)} EUR`}</td>
        <td>{`${parseFloat(element.manual_bonus).toFixed(2)} EUR`}</td>
        <td>{`${parseFloat(element.colaborator_bonus).toFixed(2)} EUR`}</td>
        <td>{`${parseFloat(element.total_dividend).toFixed(2)} EUR`}</td>
        <td>{`${parseFloat(element.total_dividend-element.used_dividend).toFixed(2)} EUR`}</td>
        <td>{`${parseFloat((element.used_bonus + element.used_dividend)-element.total_withdrawal).toFixed(2)} EUR`}</td>
        <td>{`${parseFloat(element.total_withdrawal).toFixed(2)} EUR`}</td>
        <td className="text-center">
          <div className="centerLink"  style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '6px',
              whiteSpace: 'nowrap',
            }}>
            <Link title="Edit Status" to="#" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal2(element)}><i className="bx bx-cog"></i></Link>
            <Link title="Edit User" to={"/edit_user/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bxs-edit"></i></Link>
            {/* <Link title="Delete User" to="#" className="font-size-14 bg-primary edit-box" onClick={() => { Delete_User(); }}><i className="bx bx-trash"></i></span> */}
            <Link title="Transactions" to={"/transaction/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-list-ul"></i></Link>
            <Link title="User KYC" to={"/user_kyc/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bxs-user-check"></i></Link>
            <Link title="Dividend Transactions" to={"/dividends_transactions/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-wallet-alt"></i></Link>
            <Link title="Withdrawal Transactions" to={"/withdrawal_request/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-transfer-alt"></i></Link>
            <Link title="User Wallet" to={"/user_wallet/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-wallet"></i></Link>
            <Link title="User Portfolio" to={"/portfolio/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-cart-alt"></i></Link>
            <Link title="Referral List" to={"/referral/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="mdi mdi-trophy-award"></i></Link>
            <Link title="Referral Reward" to={"/referral_reward/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-award"></i></Link>
            {/* <Link title="Referral Reward" to={"/referral_reward/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-award"></i></Link> */}
            {
            element.collaborator_referral_code?""
            :<Link title="Make Collaborator" to="#" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal(element)}><i className="fas fa-handshake"></i></Link>
            }
            <Link title="Tax Documents" to={"/tax_documents/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bxs-file-doc"></i></Link>
            <Link title="User Bonus" to={"/user_bonus/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-gift"></i></Link>
            {/* <Button className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal(element)}><i className="bx bx-cog"></i></Button> */}
          </div>
        </td>
      </tr>
    ));

    setUsersTBody(tempTBody);
  }
  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let originalText = res.data;
      originalText = originalText.filter(element => {
        return (
          element.first_name != null && element.first_name !== "" &&
          element.last_name != null && element.last_name !== "" &&
          (element.accept_terms == "true" || element.existing_user == "true" )
        );
      });

      setUsersData(originalText);

      handleT1Body(originalText);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="9" className="text-center">No records found</td>
                      </tr>);

      setUsersTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const [AllCountriesData, setAllCountriesData] = React.useState([]);
  const handleLoadGetAllCountries = async () => {
    const res = await getRequest('get-all-countries');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempArr = [{label: 'All', value: 'All'}];
      originalText.forEach(element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesData(tempArr);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  React.useEffect(() => {
    handleLoadGetUsers();
    handleLoadGetAllCountries();

    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
		}
  }, []);

  React.useEffect(() => {
  // only logic related to selectedUsers
  handleT1Body(UsersData);
}, [selectedUsers]);

  const [CsvData, setCsvData] = React.useState([]);
  const handleDownloadCSV = () => {
  const filteredUsers = CsvData.filter(user =>
    selectedUsers.includes(user.u_id)
  );

  if (filteredUsers.length === 0) {
    setAlertData((AlertData) => ({
      ...AlertData,
      variant: 'error',
      message: 'Please select Users!',
    }));
    resetAlertData();

    return false;
  }

  const transformedData = filteredUsers.map(user => ({
    u_id: user.u_id, 
    "first_name": user.first_name,
    "last_name": user.last_name,
    "email": user.email,
    "country": user.country,
    "phone_code": user.country_code,
    "phone": user.phone,
    "dob": (() => {
      if (user.dob) {
        return moment(user.dob).format('DD/MM/YYYY');
      } else {
        return "-";
      }
    })(),
    "address": user.address,
    "building": user.building ? user.building : "-",
    "floor": user.floor ? user.floor : "-",
    "zip": user.zip ? user.zip : "-",
    "tax_residency": user.tax_residency,
    "tax_id": user.tax_id,
  }));

  const csv = Papa.unparse(transformedData);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

  const filename = `users-selected_${moment().format('DDMMYYYY_HHmmss')}.csv`;
  saveAs(blob, filename);
};

const handleUploadCSV = (e) => {
  const file = e.target.files[0];

  if (!file) return;

  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: async function (results) {
      const data = results.data;

      console.log("Parsed CSV:", data);

      await bulkUpdateUsers(data);
    }
  });
};

const bulkUpdateUsers = async (users) => {
  try {
    const res = await postRequest(
      "bulk-update-users",
      JSON.stringify({ users })
    );

    if (res.code === 200) {
      setAlertData({
        variant: "success",
        message: "Users updated successfully",
      });
      handleLoadGetUsers();
    } else {
      setAlertData({
        variant: "error",
        message: res.message,
      });
    }

    resetAlertData();
  } catch (err) {
    console.error(err);
  }
};

  const [File, setFile] = useState();
  const [FileName, setFileName] = useState('');
  const saveFile = (e) => {
    if((e.target.files).length > 0) {
      setFile(e.target.files[0]);
      setFileName(e.target.files[0].name);

      var validationRes = checkCSVFileValidation(e.target.files[0]);
      if (!validationRes.status) {
        setFile();
        setFileName('');

        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: validationRes.msg,
        }));
        resetAlertData();

        return false;
      }
    }
  };

  const validation3 = useFormik({
    enableReinitialize: true,
    initialValues: {
        file: null
      },
    onSubmit: async () => {
      try {
        if (!File || FileName == '') {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: 'Please select a CSV File!',
          }));
          resetAlertData();

          return false;
        } else{
          let submit1 = document.getElementById('submit3');
          submit1.disabled = true;
          submit1.textContent = 'Processing...';

          const formData = new FormData();
          formData.append("file", File);
          formData.append("fileName", FileName);
          const res = await postRequestByFormData('update-users-with-csv', formData);
          if (res && res.code === 200) {
            handleLoadGetUsers();
            setStandardModal3(false);
            setFile();
            setFileName('');

            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));
          }
          else {
            setFile();
            setFileName('');
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
            }));
          }
          resetAlertData();

          submit1.disabled = false;
          submit1.textContent = 'Submit';

          setStandardModal2(false);
        }

      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("User Management")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="row">
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">KYC Status : </label>
                          <select className="form-select" name="kyc_status" value={validation1.values.kyc_status} onChange={(e) => validation1.setValues({ ...validation1.values, kyc_status: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Pending'}>Pending</option>
                            <option value={'Approved'}>Approved</option>
                            <option value={'Cancelled'}>Cancelled</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Status : </label>
                          <select className="form-select" name="status" value={validation1.values.status} onChange={(e) => validation1.setValues({ ...validation1.values, status: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Enable'}>Enable</option>
                            <option value={'Disable'}>Disable</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3 Register-Select2">
                          <label className="form-label">Country : </label>
                          <Select styles={colourStyles} value={validation1.values.country} onChange={(e) => validation1.setValues({ ...validation1.values, country: e })} options={AllCountriesData} classNamePrefix="select2-selection" />
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label fullWidth">&nbsp; </label>
                          <Button type="button" 
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                          color="primary">Search</Button>
                          <Button type="button" 
                           style={{ float: "right", marginLeft: "10px"}}
                            onClick={(e)=>togStandardModal3()}
                          color="primary">Upload</Button>
                          <Button type="button" onClick={handleDownloadCSV} color="primary" className="bx bx-download" style={{ float: "right", marginLeft: "10px"}} />

                        </div>
                      </Col>
                    </div>
                    <div className="table-responsive mb-0">
                      <table className="table table-hover table-highlight" style={{ minWidth: '1500px' }}>
                        <thead>
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedUsers(UsersData.map(u => u.u_id));
                                  } else {
                                    setSelectedUsers([]);
                                  }
                                }}
                              />
                            </th>
                            <th>#</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email ID</th>
                            <th>Country Name</th>
                            <th>Mobile No.</th>
                            <th>Date Of Birth</th>
                            <th className="text-center" style={{ width: '500px' }}>Address</th>
                            <th>Building</th>
                            <th>Floor</th>
                            <th>Zip Address</th>
                            <th>Tax Residency</th>
                            <th>Tax ID</th>
                            <th>KYC Status</th>
                            <th>Status</th>
                            <th>Euro Balance</th>
                            <th>Real Euro Balance</th>
                            <th>Bonus Balance</th>
                            <th>Matic Balance</th>
                            <th>USDT Balance</th>
                            <th>Total Bonus</th>
                            <th>Welcome Bonus</th>
                            <th>Referral Bonus</th>
                            <th>Manual Bonus</th>
                            <th>Collaborator Bonus</th>
                            <th>Total Dividend</th>
                            <th>Dividend Balance</th>
                            <th>Total Re-Invested</th>
                            <th>Total Withdrawn</th>
                            <th className="text-center" style={{ width: '500px' }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {UsersTBody}
                        </tbody>
                      </table>
                    </div>
                    <div className="infoIcon">

                      <div className="infoIconBox">
                        <i className="bx bxs-edit"></i>
                        <p>Edit User</p>
                      </div>

                      {/* <div className="infoIconBox">
                        <i className="bx bx-trash"></i>
                        <p>Delete User</p>
                      </div> */}

                      <div className="infoIconBox">
                        <i className="bx bx-list-ul"></i>
                        <p>Transactions</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bxs-user-check"></i>
                        <p>User KYC</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-wallet-alt"></i>
                        <p>Dividend Transactions</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-transfer-alt"></i>
                        <p>Withdrawal Transactions</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-wallet"></i>
                        <p>User Wallet</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-cart-alt"></i>
                        <p>User Portfolio</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="mdi mdi-trophy-award"></i>
                        <p>Referral List</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-award"></i>
                        <p>Referral Reward</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="fas fa-handshake"></i>
                        <p>Make Collaborator</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bxs-file-doc"></i>
                        <p>Tax Documents</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-gift"></i>
                        <p>User Bonus</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>

      <Modal isOpen={modal_Delete_User} toggle={() => { Delete_User(); }} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Delete User</h5>
            <button type="button" onClick={() => { setmodal_Delete_User(false); }} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <p>Are you sure you wan't to delete this user?</p>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={() => { setmodal_Delete_User(false); }} >Delete</Button>
            <Button type="button" color="light" onClick={() => { setmodal_Delete_User(false); }} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>

      <Modal isOpen={StandardModal2} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Change Status</h5>
            <button type="button" onClick={(e)=>setStandardModal2(false)} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label">Select Status :</label>
              <select className="form-select" name="status" value={validation2.values.status} onChange={(e) => validation2.setValues({ ...validation2.values, status: e.target.value })}>
                <option value="Enable">Enable</option>
                <option value="Disable">Disable</option>
              </select>
              {validation2.touched.status && validation2.errors.status ? (
                <FormFeedback type="invalid">{validation2.errors.status}</FormFeedback>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary"
              id="submit2"
              onClick={(e) => {
                e.preventDefault();
                validation2.handleSubmit();
                return false;
              }}
            >Update</Button>
            <Button type="button" color="light" onClick={(e)=>setStandardModal2(false)} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>

      <Modal isOpen={StandardModal} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Make Collaborator</h5>
            <button type="button" onClick={(e)=>setStandardModal(false)} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
          <div className="mb-3">
                    <Label className="form-label">Welcome Bonus :</Label>
                    <Input
                      name="welcome_bonus" 
                      type="text" 
                      placeholder={'Enter Welcome Bonus'}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.welcome_bonus || ""}
                      invalid={
                        validation.touched.welcome_bonus && validation.errors.welcome_bonus ? true : false
                      }
                    />
                    {validation.touched.welcome_bonus && validation.errors.welcome_bonus ? (
                      <FormFeedback type="invalid">{validation.errors.welcome_bonus}</FormFeedback>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <Label className="form-label">Referral code  :</Label>
                    <Input
                      name="referral_code" 
                      type="text" 
                      placeholder={'Enter Referral code'}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.referral_code || ""}
                      invalid={
                        validation.touched.referral_code && validation.errors.referral_code ? true : false
                      }
                    />
                    {validation.touched.referral_code && validation.errors.referral_code ? (
                      <FormFeedback type="invalid">{validation.errors.referral_code}</FormFeedback>
                    ) : null}
                  </div>
          </ModalBody>
          <ModalFooter>
            <Button 
              id="submit1"
              onClick={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            type="button" color="primary" >Submit</Button>
            <Button type="button" color="light" onClick={(e)=>setStandardModal(false)} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>
                <Modal className="transation" centered backdrop="static" isOpen={StandardModal3}>
                  
                    <div className="modal-header">
                      <label className="form-label">Upload Users Updated CSV Sheet:</label>
                    </div>
                    <div className="mb-3">
                      <Input type="file" className="fileUpload" accept=".csv" onChange={saveFile} />
                    </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-primary" 
                      id="submit3"
                      onClick={(e) => {
                        e.preventDefault();
                        validation3.handleSubmit();
                        return false;
                      }}
                    >Submit</button>
                    <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e)=>setStandardModal3(false)} aria-label="Close">Close</button>
                  </div>
                </Modal>

    </React.Fragment>
  );
};

export default withTranslation()(UserManagement);